// The two sources of activity lines, for the import sections, the pills and
// the reports. Plain ESM with no imports so the same source serves Node and
// Vite.

export const ACTIVITY_SOURCE = {
  FRANCHISEE_INVOICE: 'FRANCHISEE_INVOICE',
  CUSTOMER_BILL: 'CUSTOMER_BILL',
}

export const ACTIVITY_SOURCES = [
  {
    value: ACTIVITY_SOURCE.FRANCHISEE_INVOICE,
    label: 'Franchisee invoices',
    description:
      'What the clinics invoiced FTFS for National Accounts work. Owner revenue: it feeds the Customers directory for every role and My Activity for each owner.',
  },
  {
    value: ACTIVITY_SOURCE.CUSTOMER_BILL,
    label: 'Customer bills',
    description:
      'What FTFS billed the customer. FTFS revenue: admin only, shown in the directory and on customer detail.',
  },
]

export const ACTIVITY_SOURCE_VALUES = ACTIVITY_SOURCES.map((source) => source.value)
export const activitySourceLabel = (value) =>
  ACTIVITY_SOURCES.find((source) => source.value === value)?.label ?? value
